class Map {
    constructor() {
        this.map = document.querySelector('.js-map');
        this.mapMockup = document.querySelector('.js-map-mockup');
        this.mapWrapper = document.querySelector('.js-map-wrapper');
        this.triggers = document.querySelectorAll('.js-map-trigger');

        if (this.map && this.triggers) {
            this.iframeSrc = this.map.dataset.iframeSrc;

            this.triggers.forEach((element) => {
                this.initEvent(element);
            });
        }
    }

    initEvent(element) {
        element.addEventListener('click', () => { this.switchContent(); });
    }

    switchContent() {
        if (this.map.style.display !== 'block') {
            this.mapMockup.style.display = 'none';
            this.mapWrapper.style.display = 'block';
            this.map.style.display = 'block';
            this.map.src = this.iframeSrc;
        } else {
            this.mapMockup.style.display = 'block';
            this.mapWrapper.style.display = 'none';
            this.map.style.display = 'none';
            this.map.src = '';
        }
    }
}

const map = {
    init() {
        return new Map();
    },
};

export default map;
